import { put, select } from "redux-saga/effects";
import { actions } from "../../actions";
import { IStoreState } from "../../../../reducers/types";
import { getSession } from "../../reducer";
import { getPurchaseApis } from "../../utils";

export function* closeSessionSaga(_: actions.ICloseSession) {
  try {
    const state: IStoreState = yield select();
    const session = getSession(state);
    const { closeSession } = getPurchaseApis();

    if (session) {
      yield closeSession({
        token: session,
      });
      yield put(actions.clearSession());
    }
  } catch (e) {
    yield put(actions.clearSession());
  }
}
